module.exports = __webpack_public_path__ + "img/ea.e056b767.png";